import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const LIVECHAT_URL = `${API_URL}/admin/livechat`

export function getLivechat(params={}) {
  return axios.get(LIVECHAT_URL, {
    params
  }).then(res=>res.data)
}

export function getLivechatById(sessionId: string) {
  return axios.get(LIVECHAT_URL + '/' + sessionId)
}

export function enableBotLivechat(sessionId: string, status:boolean) {
  return axios.post(LIVECHAT_URL + '/' + sessionId + "/bot", {
    status
  })
}

export function sendMesssageToLivechat(sessionId: string, message:any) {
  return axios.post(LIVECHAT_URL + '/' + sessionId + '/messages', message)
}

export function getLivechatMessage(sessionId: string) {
  return axios.get(LIVECHAT_URL + '/' + sessionId + '/messages')
}
